import { observer } from "mobx-react"; // MobX observer for reactivity
import React, { useEffect, useState } from "react"; // React imports
import { Modal } from "react-bootstrap"; // Bootstrap modal component
import { useStore } from "../../../../contexts/store-provider"; // Custom store context
import { getStoreIdFromLocalStorage } from "../../../../helpers/localstorage-helper"; // Helper to get store ID
import DeletePopupHOC from "../../../../shared-components/popup/delete/delete-popup-hoc"; // Higher-order component for delete popup
import { formatMessage } from "../../../../translations/format-message"; // Translation helper
import ShiftSelector from "../form-component/assign-staff-shift-form-component"; // Shift selector component
import toast from "react-hot-toast"; // Toast notification library

interface IProps {
  id: number; // ID of the shift
  staffId: number; // ID of the staff
  onModalClosed: () => void; // Callback when modal is closed
  storeId: number; // Store ID
}

const AssignStaffShiftComponent = (props: IProps) => {
  const { shiftManagementStore, masterManagementStore } = useStore(); // Accessing shift management store
  const {
    GetShiftScheduleListByStoreIdDateUserIdService, // Service to get shift schedule list
    getShiftScheduleListState, // State of shift schedule list fetch
    getShiftScheduleList, // Shift schedule list
    GetShiftManagementListByStoreIdService, // Service to get shift management list
    inProgress, // Loading state
    allShiftOption, // All shift options
    resetGetShiftScheduleList, // Reset shift schedule list state
    AddShiftScheduleService, // Service to add shift schedule
    addShiftScheduleListState, // State of add shift schedule service
  } = shiftManagementStore;

  const {reservationSettingBusinessVM} = masterManagementStore;

  // Fetch shift schedule list for the staff on component mount
  useEffect(() => {
    // GetShiftManagementListByStoreIdService(props.storeId); // Fetch shift management list
    if (props.staffId > 0) {
      const date = new Date(localStorage.getItem("currentDate")!); // Get current date from local storage
      GetShiftScheduleListByStoreIdDateUserIdService(
        props.storeId,
        date,
        date,
        props.staffId
      ); // Fetch shift schedule list
    }
  }, []);

  useEffect(() => {
    if (getShiftScheduleList?.length === 0) {
      GetShiftManagementListByStoreIdService(props.storeId, reservationSettingBusinessVM); // Fetch all shift schedule list
    }
  }, [getShiftScheduleList]);

  // Fetch shift management list when shift schedule list fetch is successful
  useEffect(() => {
    if (addShiftScheduleListState.success) {
      toast.success(formatMessage("updated_success")); // Show success toast
      onModalClosed(); // Close modal
    }
  }, [addShiftScheduleListState.success]);

  // Handle form submission for assigning a shift
  const onSubmitForm = (values: any) => {
    if (getShiftScheduleList?.length === 0) {
      // Logic for submitting the form
      let schedule = [
        {
          Id: Number(values?.selectedShift), // Selected shift ID
          StaffId: props.staffId, // Staff ID
          StoreId: props.storeId, // Store ID
          ScheduleType: 0, // Schedule type
          Date: localStorage.getItem("currentDate"), // Current date
          FreeStartTime: "00:00:00", // Default start time
          FreeEndTime: "00:00:00", // Default end time
        },
      ];

      AddShiftScheduleService(schedule); // Add shift schedule
    }
  };

  // Handle modal close event and reset state
  const onModalClosed = () => {
    resetGetShiftScheduleList(); // Reset shift schedule list state
    props.onModalClosed(); // Call parent modal close handler
  };

  return (
    <React.Fragment>
      <Modal show={true} centered size="sm">
        {" "}
        {/* Modal component */}
        <Modal.Header>
          <Modal.Title>
            {formatMessage("assign_shift")} {/* Modal title */}
            <button onClick={onModalClosed} className="Crossicons">
              {" "}
              {/* Close button */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-2">
          <ShiftSelector
            id={props.id} // Shift ID
            submitHandler={onSubmitForm} // Form submit handler
            onModalClosed={onModalClosed} // Modal close handler
            isLoading={
              getShiftScheduleListState.inProgress || // Loading state for shift schedule list
              inProgress || // General loading state
              addShiftScheduleListState.inProgress // Loading state for adding shift schedule
            }
            staffId={props.staffId} // Staff ID
            shiftList={allShiftOption} // List of all shifts
            shiftScheduleList={getShiftScheduleList} // List of shift schedules
            initialValues={{
              selectedShift: "-1", // Default value for shift selection
            }}
          />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default DeletePopupHOC(observer(AssignStaffShiftComponent)); // Export component with HOC and observer
